export default "__VITE_ASSET__acab8352__"